export { isRecentCookieTimestamp, hasIgnoredCookies, hasAcceptedCookies } from './cookies';
